import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

class InsertAnchorUI extends Plugin {
  init() {
    const editor = this.editor;
    const insertAnchorCommand = editor.commands.get('insertAnchor');
    if (!insertAnchorCommand) {
      console.error('InsertAnchorUI: insertAnchor command not found');
      return;
    }

    editor.ui.componentFactory.add('insertAnchor', () => {
      const button = new ButtonView();

      button.set({
        label: 'Insert anchor',
        withText: true,
      });

      button.on('execute', () => {
        const event = new CustomEvent('ckeditor-insert-anchor-click', {
          bubbles: true,
          detail: { editor },
        });
        window.dispatchEvent(event);
      });

      return button;
    });
  }
}

export default InsertAnchorUI;
